// Define your store details and access token
const shopifyDomain = 'paulas-choice-thailand.myshopify.com';
const storefrontAccessToken = '4966cbc1900a400049ef078e41c17ad6';

// Function to fetch product by SKU
async function fetchProductBySKU(skus) {
  let lastCursor = null; // Track the last cursor for pagination
  const pageSize = 50;
  let remainingSKUs = new Set(skus);
  const foundProducts = [];

  while (true) {
    // Define the GraphQL query
    const graphqlQuery = {
      query: `{
        products(first: ${pageSize}${
        lastCursor ? `, after: "${lastCursor}"` : ''
      }) {
          edges {
            node {
              id
              title
              handle
              variants(first: 2) {
                edges {
                  node {
                    sku
                    id
                    image {
                      id
                      url
                    }
                    priceV2 {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }`,
    };

    try {
      const response = await fetch(
        `https://${shopifyDomain}/api/2024-07/graphql.json`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
            Accept: 'application/json',
          },
          body: JSON.stringify(graphqlQuery),
        }
      );

      const data = await response.json();
      const products = data.data.products.edges;

      for (let edge of products) {
        edge.node.variants.edges.forEach((variant) => {
          if (remainingSKUs.has(variant.node.sku)) {
            foundProducts.push({
              ...variant.node,
              productHandle: edge.node.handle,
              productName: edge.node.title,
              productId: edge.node.id,
            });
            remainingSKUs.delete(variant.node.sku);
          }
        });
      }

      if (!data.data.products.pageInfo.hasNextPage || products.length === 0) {
        console.log('No more products to search through.');
        break;
      }

      // Prepare the cursor for the next page of products
      lastCursor = products[products.length - 1].cursor;
    } catch (error) {
      console.error('Error fetching products:', error);
      return null;
    }
  }

  return foundProducts;
}

// Call the function with the desired SKU
// Demo on how to call that function above
/*
fetchProductBySKU(['2900', '2901', '1010', '8500'])
  .then((foundProducts) => {
    console.log('Final list of found products:', foundProducts);
  })
  .catch((error) => {
    console.error('Error in fetching products:', error);
  });
  */
